import { render } from "./Select.vue?vue&type=template&id=16d183a0&scoped=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=16d183a0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-16d183a0"

export default script